// Updated AppAdmin.jsx with new routes
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminPortal from './AdminPortal';
import RuntimeWizardLoader from './loaders/RuntimeWizardLoader';
import AdminCheck from './auth/AdminCheck';
import { ThemeProvider } from './themes/ThemeContext';
import WizardSummariesList from './public-forms/WizardSummariesList';
import RuntimeWizardWithBackground from './public-forms/RuntimeWizardWithBackground';

function AppAdmin() {
  return (
    <Router>
      <Routes>
        {/* Protected Admin Route */}
        <Route
          path="/admin/*"
          element={
            <AdminCheck>
              <ThemeProvider initialTheme="light">
                <AdminPortal />
              </ThemeProvider>
            </AdminCheck>
          }
        />

        {/* Public Forms List - Light Theme */}
        <Route
          path="/forms"
          element={
            <AdminCheck>
              <ThemeProvider initialTheme="light">
                <WizardSummariesList />
              </ThemeProvider>
            </AdminCheck>

          }
        />

        {/* Public Form with Background - Light Theme */}
        <Route
          path="/forms/active/:wizardId/:urlSlug"
          element={
            <ThemeProvider initialTheme="light">
              <RuntimeWizardWithBackground />
            </ThemeProvider>
          }
        />

        {/* Existing Wizard Routes - Light Theme */}
        <Route
          path="/wizard/:wizardId"
          element={
            <ThemeProvider initialTheme="light">
              <RuntimeWizardLoader />
            </ThemeProvider>
          }
        />

        <Route
          path="/wizard"
          element={
            <ThemeProvider initialTheme="light">
              <RuntimeWizardLoader />
            </ThemeProvider>
          }
        />

        {/* Default Route - Form Wizard with Light Theme */}
        <Route
          path="/"
          element={
            <AdminCheck>
              <ThemeProvider initialTheme="light">
                <WizardSummariesList />
              </ThemeProvider>
            </AdminCheck>
          }
        />

        {/* Catch-all Route */}
        <Route
          path="*"
          element={
            <ThemeProvider initialTheme="light">
              <Navigate to="/" replace />
            </ThemeProvider>
          }
        />
      </Routes>
    </Router>
  );
}

export default AppAdmin;